"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriptionModuleContent = void 0;
var _zod = require("@hookform/resolvers/zod");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _reactDom = require("react-dom");
var _reactHookForm = require("react-hook-form");
var _hooks = require("../../hooks");
var _components = require("./components");
var _constants = require("./constants");
var _context = require("./context");
var _hooks2 = require("./hooks");
var _styles = require("./styles");
var _types = require("./types");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
const SubscriptionModuleContent = props => {
  const {
    itemCode,
    recommendedFrequency,
    deliveryFrequencyOptions,
    analyticsData,
    addToBagContainerId,
    disabled,
    lineNumber,
    originalQuantity,
    subscriptionPlacement,
    showDeliveryFrequencySelect,
    standalone: {
      onChange
    } = {}
  } = props;
  const [addToBagContainer, setAddToBagContainer] = (0, _react.useState)(null);
  const isStandalone = Boolean(onChange);
  (0, _react.useEffect)(() => {
    setAddToBagContainer(addToBagContainerId ? document.getElementById(addToBagContainerId) : null);
  }, [addToBagContainerId]);
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const {
    onAddToBag
  } = (0, _hooks2.useAddToBag)({
    analyticsData,
    itemCode,
    lineNumber,
    originalQuantity,
    subscriptionPlacement
  });
  const form = (0, _reactHookForm.useForm)({
    defaultValues: {
      frequency: (0, _utils.getDefaultDeliveryFrequency)({
        deliveryFrequencyOptions,
        recommendedFrequency,
        translations
      }),
      mode: _types.SubscriptionModuleMode.Subscribe
    },
    disabled,
    resolver: (0, _zod.zodResolver)(_constants.subscriptionModuleFormValidationSchema)
  });
  const {
    control,
    handleSubmit,
    watch
  } = form;

  // istanbul ignore next -- not easily testable
  (0, _react.useEffect)(() => {
    if (!isStandalone || !onChange) {
      return undefined;
    }
    const subscription = watch(value => {
      onChange(value);
    });
    return () => subscription.unsubscribe();
  }, [isStandalone, onChange, watch]);
  const onAddToBagClick = (0, _react.useCallback)(quantity => {
    void handleSubmit(async ({
      frequency,
      mode
    }) => onAddToBag({
      frequency,
      mode,
      quantity
    }))();
  }, [handleSubmit, onAddToBag]);
  const renderRadioButton = (0, _react.useCallback)(({
    field
  }) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.RadioGroup, {
    ...field,
    defaultValue: _types.SubscriptionModuleMode.Subscribe,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
      "data-testid": getTestId(_constants.SUBSCRIPTION_MODULE),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.SubscribeOption, {
        showDeliveryFrequencySelect: showDeliveryFrequencySelect
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.PurchaseOption, {}), addToBagContainer ? /*#__PURE__*/(0, _reactDom.createPortal)(/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.AddToBag, {
        onAddToBagClick: onAddToBagClick
      }), addToBagContainer) : null, !!addToBagContainerId || isStandalone ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.AddToBag, {
        onAddToBagClick: onAddToBagClick
      })]
    })
  }), [addToBagContainer, addToBagContainerId, getTestId, isStandalone, onAddToBagClick, showDeliveryFrequencySelect]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_context.SubscriptionModuleProvider, {
    value: props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactHookForm.FormProvider, {
      ...form,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("form", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactHookForm.Controller, {
          name: "mode",
          control: control,
          render: renderRadioButton,
          disabled: disabled
        })
      })
    })
  });
};
exports.SubscriptionModuleContent = SubscriptionModuleContent;
